export interface IAndroidAmbientLightStatus {
  supported: boolean
  running: boolean
  /** Latest reading in lux; only while sampling and after the first reading. */
  lux?: number
}

export function parseAndroidAmbientLightStatus(raw: unknown): IAndroidAmbientLightStatus | null {
  if (raw == null || typeof raw !== 'object') {
    return null
  }
  const o = raw as Record<string, unknown>
  if (typeof o.supported !== 'boolean' || typeof o.running !== 'boolean') {
    return null
  }
  const status: IAndroidAmbientLightStatus = { supported: o.supported, running: o.running }
  if (typeof o.lux === 'number' && Number.isFinite(o.lux) && o.lux >= 0) {
    status.lux = o.lux
  }
  return status
}
